import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

interface DecodedToken {
  id: string;
  role: string;
  hasProvidedAdditionalInfo?: boolean;
  // Add other properties from your JWT payload here
}

const OAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const handleLogin = async (token: string, userStr: string | null) => {
      try {
        if (!userStr) {
          throw new Error('User data not found in URL');
        }
        const user = JSON.parse(userStr);
        await login(user, token);

        if (!user.hasProvidedAdditionalInfo) {
          navigate('/social-onboarding');
        } else {
          const response = await axios.get('/api/daily-journals/today', {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (response.data.hasSubmittedToday) {
            navigate('/');
          } else {
            navigate('/daily-journal');
          }
        }
      } catch (error) {
        console.error('Login failed:', error);
        navigate('/login');
      }
    };

    const token = searchParams.get('token');
    const userStr = searchParams.get('user');
    if (token) {
      handleLogin(token, userStr);
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate, login]);

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <p>로그인 처리 중입니다. 잠시만 기다려 주세요...</p>
    </div>
  );
};

export default OAuthCallback;
